import { render, staticRenderFns } from "./Cert.vue?vue&type=template&id=662f11da&scoped=true"
import script from "./Cert.vue?vue&type=script&lang=js"
export * from "./Cert.vue?vue&type=script&lang=js"
import style0 from "./Cert.vue?vue&type=style&index=0&id=662f11da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662f11da",
  null
  
)

export default component.exports